<template>
  <v-container>
    <p class="text-body-1">At <i>findmykit</i> we have revolutionised the traditional name tag</p>
    <p class="text-body-1">Previously, with just the name, if your items were lost somewhere out of context to where you would have them, (which is normally exactly how items do get lost) having your name on the item is suddenly irrelevant.</p>
    <p class="text-body-1">At <i>findmykit</i>, we have the solution for this problem, with our unique PET technology, the traditional name tag has been transformed into your own unique QR code. These Can be made to display yours or a family members name, or completely free of the name entirely.</p>
    <p class="text-body-1">If you wish to purchase personalised smart tags, then you will need to add a dependant, and then select the dependant in the drop down menu at checkout, you can assign as many dependants as you need.</p>
    <p class="text-body-1">To order your tags, simply select which product you would like to purchase from our shop, if it is a personalised item, select the dependant and check out.</p>
    <p class="text-body-1">Sit back and wait for your tags to arrive.</p>
    <p class="text-body-1">Depending on what product you have ordered, when they arrive, follow the instructions on how to affix your <i>findmykit</i> smart tags to your items and even directly to family members!</p>
    <p class="text-body-1">When one of the items you have misplaced with one of your <i>findmykit</i> smart tags is scanned, it will either be from a vetted organisation registered with <i>findmykit</i>, or a member of the public using our returns process. You will receive an alert by text and email.</p>
    <p class="text-body-1">If the tag was scanned by an organisation, then the alert will advise that the item has been found, and will be ready for collection from the organisation that scanned it.</p>
    <p class="text-body-1">If the alert has been generated from a member of the public you will receive a <i>findmykit</i> returns process email, explaining how we will help facilitate the return of your item. Don't worry we have carefully designed the process so it is anonymous and safe. Both you and the finder will need to agree to our returns process terms, and then anonymously communicate with each other via email, to organise the return of your item.</p>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "IndividualsContent",
  computed: {
    ...mapState({
      brand: state => state.brand,
brandName: state => state.brandName
    }),
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
}
</script>

<style scoped>

</style>
